import React from 'react';
import styled from 'styled-components';

function Section({children, type, layout}) {
    return (
        <SectionElement type={type} layout={layout}>
            {children}
        </SectionElement>
    );
}

export default Section;

const SectionElement = styled.section`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: ${props => props.type === 'slim' ? '90%' : '100%'};
  max-width: ${props => props.type === 'slim' ? '1420px' : '100%'};

  @media (min-width: 1024px) {
    flex-direction: ${props => props.layout === 'row' ? 'row' : 'column'};
  }

  h1 {
    font-size: 32px;
    margin: 0 0 16px 0;
    font-weight: 900;
    line-height: 1.3;

    @media (min-width: 1024px) {
      font-size: 38px;
    }
  }

  h2 {
    font-size: 26px;
    margin: 16px 0;
    line-height: 1.3;

    @media (min-width: 1024px) {
      font-size: 32px;
    }
  }

  h3 {
    font-size: 22px;
    margin: 16px 0;
    line-height: 1.3;

    @media (min-width: 1024px) {
      font-size: 26px;
    }
  }

  h4 {
    font-size: 18px;
    margin: 16px 0;
    line-height: 1.3;

    @media (min-width: 1024px) {
      font-size: 22px;
    }
  }

  h5 {
    font-size: 18px;
    margin: 16px 0;
  }

  h6 {
    font-size: 16px;
    margin: 16px 0;
  }

  p {
    font-size: 18px;
    margin: 16px 0;
  }
`;